import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Show.svg?component
var Show_exports = /* @__PURE__ */ __exportAll({
	default: () => Show_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7"
	}, null, -1), createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
	}, null, -1)])]);
}
var Show_default = { render: render$1 };
//#endregion
export { Show_exports, Show_default as default, render$1 as render };

//# sourceMappingURL=Show.svg.virtual.js.map